<form class="c-form" name="vm.form" #mainForm="ngForm">
	<div class="o-grid o-grid--center-h">
		<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up o-grid__cell--w-35@lg-and-up u-no-p">
			<section class="c-section c-section--first c-section--last" panel [isOpen]="vm.isPanelOpen" [ngClass]="{ 'c-section--error': vm.submitted && mainForm.invalid }">
				<div class="c-section__header">
					<h1 id="bookingAddressStepTitle" class="c-section__title c-section__title--sm">{{ 'Address.Title' | translate }}</h1>
				</div>
				<div class="c-section__content" *ngIf="vm.initialized">
					<div class="o-grid">
						<div class="o-grid__cell c-cell">
							<div class="c-card" [ngClass]="{ 'c-card--error': vm.submitted && mainForm.invalid }">
								<div class="c-content">
									<p class="c-text">{{ 'Address.Address_Disclaimer' | translate }}</p>
								</div>
								<div class="c-content">
									<div class="o-grid">
										<div class="o-grid__cell u-no-pl">
											<p id="bookingExpiredLabel" class="c-text c-text--bold c-text--s3" *ngIf="vm.isExpired">{{ 'Booking.Expired' | translate }}</p>
											<p id="bookingTimeLeftLabel" class="c-text c-text--bold c-text--s3" *ngIf="!vm.isExpired">{{ 'Booking.Time_Left' | translate }}</p>
										</div>
										<div class="o-grid__cell o-grid__cell--w-fixed u-no-p" *ngIf="!vm.isExpired">
											<p id="bookingExpiresTimer" class="c-text c-text--bold c-text--right c-text--s3">{{ vm.expiresIn }}</p>
										</div>
									</div>
								</div>
								<div class="c-content">
									<div class="c-form__group" [ngClass]="{'c-form__group--error': vm.submitted && vm.countryInvalid}">
										<label for="country" class="c-form__label">{{ 'Address.Country' | translate }}</label>
										<mat-select id="country" name="country" [(value)]="vm.address.country" (change)="vm.getCounties()" class="mat-select mat-select--border" [disabled]="vm.isExpired || vm.isProcessing">
											<mat-option *ngFor="let country of vm.countries" [value]="country.name">{{country.name}} ({{country.code}})</mat-option>
										</mat-select>
									</div>
									<div class="c-form__group" [ngClass]="{'c-form__group--error': vm.submitted && city.invalid}">
										<label for="city" class="c-form__label">{{ 'Address.City' | translate }}</label>
										<input id="city" name="city" type="text" class="c-form__input" [(ngModel)]="vm.address.city" #city="ngModel" maxlength="32" required [disabled]="vm.isExpired || vm.isProcessing">
									</div>
									<div class="c-form__group" [ngClass]="{'c-form__group--error': vm.submitted && address.invalid}">
										<label for="address" class="c-form__label">{{ 'Address.Address' | translate }}</label>
										<input id="address" name="address" type="text" class="c-form__input" [(ngModel)]="vm.address.address" #address="ngModel" maxlength="100" required [disabled]="vm.isExpired || vm.isProcessing">
									</div>
									<div class="c-form__group u-no-m" [ngClass]="{'c-form__group--error': vm.submitted && zipCode.invalid}">
										<label for="zip" class="c-form__label">{{ 'Address.Zip_Code' | translate }}</label>
										<input id="zip" name="zip" type="text" class="c-form__input" [(ngModel)]="vm.address.zipCode" #zipCode="ngModel" maxlength="15" required [disabled]="vm.isExpired || vm.isProcessing">
									</div>
									<loader-overlay *ngIf="vm.isProcessing"></loader-overlay>
								</div>
							</div>
						</div>
					</div>
					<div class="c-content u-no-pb u-no-p@md-and-up">
						<div class="o-grid">
							<div class="o-grid__cell u-hidden@up-to-md"></div>
							<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-hidden@up-to-md">
								<a id="bookingAddressStepBackButton" [routerLink]="['/booking/service', vm.serviceId]" class="c-button c-button--link c-button--lg">{{ 'Booking.Button.Back' | translate }}</a>
							</div>
							<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p@up-to-md">
								<button id="saveAddressButton" type="button" class="c-button c-button--s2 c-button--fit c-button--lg" (click)="vm.handleFormSubmit(mainForm)" [disabled]="vm.isExpired || vm.isProcessing">{{ 'Address.Save' | translate }}</button>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</form>
